module.exports = __webpack_public_path__ + "static/media/auditorium-screen.6d767fb4.png";